import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  InputProjectInformationDialogContext,
  InputProjectInformationDialogInitialState,
} from "./";

export const InputProjectInformationDialogStateProvider = ({
  children,
}: any) => {
  const [pageState, setPageState] = useState(
    InputProjectInformationDialogInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <InputProjectInformationDialogContext.Provider value={context}>
      {children}
    </InputProjectInformationDialogContext.Provider>
  );
};
